import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from "react";
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useMemo } from 'react';
import Pdf from "../../Components/Pdf";
import PolicyManagementMenu from "../../Components/PolicyManagementMenu";
function RenewalsandCancellationspolicies() {

   
   // Row Data: The data to be displayed.
   const [rowData, setRowData] = useState([
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", }, { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Renewal ",Document: "",RenewalDate: "2026-01-01	", },
    { SubmissionID: "Policy-001	 ", PolicyTitle: "Indexed universal life insurance",  SubmittedBy: "john smith", EffectiveDate: "2025-01-01",LastUpdated: "2024-12-15", ApprovedBy: "Compliance Team	", PolicyStatus: "Cancelled  ",Document: "",RenewalDate: "2026-01-01	", },
    
    
]);




// Column Definitions: Defines the columns to be displayed.
const [colDefs, setColDefs] = useState([
     
    
    { field: "SubmissionID" },
    
    { field: "PolicyTitle" },   
    { field: "SubmittedBy" },
    { field: "EffectiveDate" },
    { field: "LastUpdated" },
    { field: "ApprovedBy" },
    { field: "PolicyStatus" },
    { field: "Document",
        cellRenderer: Pdf,       
     },
     { field: "RenewalDate" },
]);


// ...
const defaultColDef = useMemo(() => {
    return {
        flex: 1,
        filter: true,
    }

});


   
    

    return (
        <Container fluid>         
           <PolicyManagementMenu/>
          
            <Row className='m-1 pt-2'>
                <Col sm={4} className='d-flex'>
                    <h6 className='fw-bold'>Renewals and Cancellations Policies </h6>
                </Col>
                <Col sm={4} className='pb-2'>
                    
                </Col>
                <Col sm={4} >
                    <div class="dropdown float-end">
                      
                    </div>
                </Col>

                <div className="ag-theme-alpine" // applying the grid theme
                     style={{ height: 550 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 20]}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}
                       
                    />
                </div>
                
               
            </Row>
           
        </Container>

    );
}

export default RenewalsandCancellationspolicies